// extracted by mini-css-extract-plugin
module.exports = {"main":"gigawatt_project_main__A-WQ8"};